import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { Subscription, firstValueFrom } from 'rxjs';
import { Exercise } from 'src/models/exercise.model';
import { ExerciseService } from 'src/services/exercise-service.service';

@Component({
    selector: 'app-add-existing',
    templateUrl: './add-existing.component.html',
    styleUrls: ['./add-existing.component.scss'],
    standalone: false
})
export class AddExistingComponent implements OnInit, OnDestroy {
  exercises: Exercise[] = [];
  private exercisesSub!: Subscription;
  selectedExercises: Set<string> = new Set();
  @Output() exercisesEmitted = new EventEmitter<string[]>();
  @Output() closeView = new EventEmitter<null>();
  @Output() noExercise = new EventEmitter<null>();
  @Input() title = 'Select Exercises';

  toggleStates = new Map<string, boolean>();

  constructor(private exerciseService: ExerciseService, private auth: Auth) {}

  isLoading = true;

  async ngOnInit() {
    const user = await firstValueFrom(authState(this.auth));
    if (user) {
      let count = 0;
      this.exercisesSub = this.exerciseService
        .getUserExercises(user.uid)
        .subscribe((exercises) => {
          if (count) this.isLoading = false;
          this.exercises = exercises;
          count += 1;
        });
    }
  }

  ngOnDestroy() {
    if (this.exercisesSub) {
      this.exercisesSub.unsubscribe();
    }
  }

  updateSelectedExercises(
    exerciseId: string | undefined,
    isChecked: boolean
  ): void {
    if (isChecked) {
      if (exerciseId) this.selectedExercises.add(exerciseId);
    } else {
      if (exerciseId) this.selectedExercises.delete(exerciseId);
    }
  }

  emitSelectedExercises(): void {
    this.exercisesEmitted.emit(Array.from(this.selectedExercises));
    this.closeView.emit();
  }

  handleToggleStatesChange(updatedToggleStates: Map<string, boolean>) {
    this.toggleStates = updatedToggleStates;
  }

  getFilteredExercises() {
    // Check if all entries in toggleStates are false
    const allToggledOff = Array.from(this.toggleStates.values()).every(
      (value) => !value
    );

    if (allToggledOff) {
      return this.exercises; // Return all exercises if all toggleStates are off
    }

    // Filter exercises based on toggleStates
    return this.exercises.filter((exercise) =>
      exercise.hashtags.some((hashtag) => this.toggleStates.get(hashtag))
    );
  }
}
